import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ProjectViewModel } from '../../../models-views/project.view.model';
import { AppCommon } from '../../../providers/app-common';

@Component({
  selector: 'app-links',
  standalone: false,
  templateUrl: './links.component.html',
  styleUrl: './links.component.scss'
})
export class LinksComponent {

  @Input('isVisible') isVisible = false;
  @Output('isnotVisible') isnotVisible = new EventEmitter<boolean>() ;
  @Output() linksChanged = new EventEmitter<number[]>(); // Emit array of link IDs
  @Output() linkDetail = new EventEmitter<any>(); // Emit array of link IDs
  linkForm:FormGroup
  loggedInUser:any

  constructor(private fb: FormBuilder, private vm: ProjectViewModel) {
    this.loggedInUser = AppCommon.getloggedInObject().user
    this.linkForm = this.fb.group({
      type: ['1', Validators.required],
      url: ['', Validators.required],
      name: ['', Validators.required]
    });

    this.vm.linkResponse.subscribe( (e:any) => {
      this.linksChanged.emit(e);
     }
    )
  }

  ngOnInit(): void {}





  addLink() {
    const linkData = this.linkForm.value;
    linkData['created_by']=this.loggedInUser.id;

    if(!linkData.url.includes('http')){
      linkData.url = 'https://' + linkData.url;
    }

    // console.log("linkData >>",linkData);
    // return;

    this.vm.createProjectLink(linkData);
    this.linkForm.reset();
    this.linkDetail.emit(linkData);
    this.isVisible = false;
    this.isnotVisible.emit(false);
  }



  showModal(): void {
    this.isVisible = true;
  }



  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.isVisible = false;
    this.isnotVisible.emit(false)
  }



}
